import { render, staticRenderFns } from "./AcctNoSfxHelplist.vue?vue&type=template&id=6e87ca42&"
import script from "./AcctNoSfxHelplist.vue?vue&type=script&lang=js&"
export * from "./AcctNoSfxHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports